module.exports = __webpack_public_path__ + "static/img/033幼儿园系统使用手册.8656dd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/033幼儿园系统使用手册.jpg
// module id = oBdz
// module chunks = 0